import React from 'react';
import styles from './ContentHeader.module.css'
import {useAppSelector} from "../../../../hooks/redux";
import {getLanguage} from "../../../../store/selectors/appSelector";
import {useNavigate} from "react-router-dom";
import {UIText} from "../../../../enums/UIText/UIText";
import ContentDescription from "./ContentDescription/ContentDescription";
import {getTextByLanguage} from "../../../../enums/utils/getTextByLanguage";

interface IProps {
    title: string,
    description?: string,
    pageName?: string,
    editable?: boolean
}

const ContentHeader = ({title, description, pageName, editable}: IProps) => {

    const language = useAppSelector(getLanguage)
    const navigate = useNavigate()

    return (
        <div className={styles.wrapper}>
            <span className={styles.buttonGoHome} onClick={() => navigate('/')}>
                {getTextByLanguage(UIText.nav.main, language)}
            </span>
            <h1 className={styles.title}>{title}</h1>
            {
                description && <ContentDescription description={description} pageName={pageName} editable={editable}/>
            }
        </div>
    );
};

export default ContentHeader;